module.exports = __webpack_public_path__ + "img/pay-pass.860de0a6.jpg";